<template>
  <div class="payment">
    <!-- 引入公共头部 -->
    <dg-header :showBack="true" :isBack="false" title="支付" @handlerBack="handlerBack"></dg-header>
    <!-- 中间内容 -->
    <section class="payment-con">
      <!-- 商品金额 -->
      <div class="list-item">
        <p class="list-item-left">商品金额</p>
        <p class="list-item-right fc04">
          <span class="small-size">JPY</span>
          {{$route.query.totalCost | setNumber}}
        </p>
      </div>
      <div class="list-item">
        <p class="list-item-left">剩余额度</p>
        <p class="list-item-right fc10">
          <span class="small-size">JPY</span>
          {{credits | setNumber}}
        </p>
      </div>
      <!-- 额度抵扣 -->
      <div class="list-item">
        <p class="list-item-left">额度抵扣</p>
        <p class="list-item-right fc10">
          <span class="small-size">JPY</span>
          {{$route.query.totalCost | setNumber}}
        </p>
      </div>
    </section>
    <!-- 底部footer -->
    <div class="payment-footer">
      <button
        class="payment-footer-btn"
        :class="{disable: credits &lt; $route.query.totalCost}"
        @click="confirmPayment"
        :disabled="credits &lt; $route.query.totalCost"
      >{{credits &lt; $route.query.totalCost ? '余额不足，请提醒充值' : '确认支付'}}</button>
    </div>
  </div>
</template>
<script>
import DgHeader from "@/components/header";
import api from "@/server";
export default {
  data() {
    return {
      userInfo: {},
      status: "",
      lastPayTime: "",
      credits: '',
    };
  },
  created() {
    this.getUserInfos();
  },
  components: {
    DgHeader
  },
  methods: {
    // 点击确认支付
    confirmPayment() {
      api
        .confirmPay({
          userId: this.userInfo._id,
          orderNumber: this.$route.query.id
        })
        .then(res => {
          if (res.code === 200 && res.data) {
            this.userInfo.credits -= res.data.totalCost;
            this.userInfo.costCredits += res.data.totalCost;
            localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
            this.status = "pay";
            this.$router.replace({
              name: "pay-success",
              query: {
                price: res.data.totalCost,
                id: res.data.orderNumber
              }
            });
          } else {
            this.orderErr(res.msg)
            this.$route.replace({
              name: 'order-list',
              query: {
                active: 0,
                id: this.userInfo._id
              }
            })
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 订单错误或者过期处理
    orderErr(msg) {
       const toast = this.$toast.loading({
              duration: 0, // 持续展示 toast
              forbidClick: true, // 禁用背景点击
              loadingType: "spinner",
              message: "即将返回 3\n" + msg
            });
            let second = 3;
            const timer = setInterval(() => {
              second--;
              if (second) {
                toast.message = '即将返回' +second +'\n' + msg ;
              } else {
                clearInterval(timer);
                toast.clear();
                this.$router.push({
                name: 'category'
              })
              }
            }, 1000);
    },
    // 点击返回历史记录监听
    handlerBack() {
      api
        .getRemindTime({
          orderNumber: this.$route.query.id
        })
        .then(res => {
          if (res.code === 200) {
            this.$dialog
              .confirm({
                title: "确认离开",
                message:
                  "您当前订单支付时间剩余" +
                  res.data.remindTime +
                  "，你确定要离开吗？"
              })
              .then(() => {
                this.$router.replace({
                  name: "order-list",
                  query: {
                    active: 0,
                    id: this.userInfo._id
                  }
                });
              })
              .catch(() => {});
          } else {
            this.$toast.fail("获取支付时间失败");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
     // 根据用户id查询用户信息
    getUserInfos() {
      api.getUserInfo({
        id: JSON.parse(localStorage.getItem('userInfo'))._id
      }).then(res=> {
        if (res.code === 200 && res.data) { 
          this.userInfo = res.data;
          this.credits = this.userInfo.credits - this.userInfo.costCredits;   
          localStorage.setItem('userInfo', JSON.stringify(res.data))
        } 
      }).catch(err=> {
        console.log(err)
      })
    }  
  }
};
</script>

<style lang="scss" scoped>
.payment {
  padding: 88px 0 96px;
  // section
  .payment-con {
    width: 100%;
    padding: 0 30px;
    margin-top: 20px;
    .list-item {
      width: 100%;
      height: 88px;
      padding: 0 30px;
      background: $bg02;
      border-radius: $br20;
      margin-bottom: 8px;
      box-shadow: $box-shadow3;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:last-child {
        margin-bottom: 0;
      }
      .list-item-left {
        font-size: 28px;
        color: $fc09;
      }
      .list-item-right {
        font-size: 30px;
        .small-size {
          font-size: 24px;
        }
      }
      .fc04 {
        color: $fc04;
      }
      .fc10 {
        color: $fc10;
      }
    }
  }
  // footer
  .payment-footer {
    width: 100%;
    max-width: 750px;
    background: $bg02;
    padding: 8px 30px;
    position: fixed;
    bottom: 0;
    border-top: 2px solid $bc04;
    .disable {
      background: $bg01 !important;
      color: $fc09 !important;
    }
    .payment-footer-btn {
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
      color: $fc02;
      font-size: 30px;
      border-radius: $br50;
      background: $bg05;
      @include resetButton();
      &:active {
        background: #789e2a;
      }
    }
  }
}
</style>
